/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@taak/react-modern-calendar-datepicker'

import { useForm } from "react-hook-form"
import { deleteItem, get, put } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useNavigate, useParams } from 'react-router-dom'

export default function index() {
  const { id } = useParams()

  const navigate = useNavigate()
  const [selectedDay, setSelectedDay] = useState('')
  const [code, setCode] = useState()
  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/offcode/${id}?token=${token}`)
      .then(response => {
        setCode(response.data.data[0])
        let defaultValues = {}
        defaultValues.code = response.data.data[0].code
        defaultValues.percent = response.data.data[0].percent
        reset({ ...defaultValues })
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    if (selectedDay !== '') {
      put(`/api/admin/offcode/${id}?token=${token}`, {
        code: data.code,
        percent: data.percent,
        enDate: selectedDay
      }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/offs')
        }, 2000)
      }).catch(error => {
        if (error.response.data.messageFa === "این کد تخفیف موجود می باشد") {
          return notify('error', 'کد تخفیف موجود می باشد')
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
    }
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/offcode/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/offs')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید کد تخفیف مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <Menu page={'offcode'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ویرایش کد تخفیف
              </div>
            </div>

            <div className='left'>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف کد تخفیف</button>
              </div>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد کد تخفیف لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات کد تخفیف‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>نام کد تخفیف * :</label>
                <input id='offCodeName' {...register("code", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='start' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='offCodePercent'>درصد کد تخفیف * :</label>
                <input id='offCodePercent' {...register("percent", { required: true, minLength: 1 })}  className='ltrdirection' type='text' placeholder='25' />
                <small id='offCodePercentAlert'>درصد کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeDate'>تاریخ اتمام {code ? `${code.enDate.year}/${code.enDate.month}/${code.enDate.day}` : ''} * :</label>
                <small id='offCodeDateAlert'>اولویت باید وارد شود</small>
                <DatePicker
                  value={selectedDay}
                  onChange={setSelectedDay}
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
              </div>
            </div>
            <button className='createButton'>آپدیت کد تخفیف</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
